import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/RoleReport`;

export default {      
    getByWorkspaceIdAndRoleIds: async (workspaceId, roleIds) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "workspaceId": workspaceId,
                "roleIds": roleIds,
                "reportId": ""
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetByWorkspaceIdAndRoleIds`, requestOptions);
        return await common.handleResponse(rs);
    },

    getByReportIdAndRoleIds: async (reportId, roleIds) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "reportId": reportId,
                "roleIds": roleIds
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetByReportIdAndRoleIds`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    createMultiple: async (body) => {
        var requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify(body),
        };
    
        let rs = await fetch(`${mainUrl}/CreateMultiple`, requestOptions);
        return await common.handleResponse(rs);
    },

    deleteByReportIdAndRoleIds: async (reportId, roleIds) => {
        var requestOptions = {
            method: 'DELETE',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "reportId": reportId,
                "roleIds": roleIds
            }),
        };
    
        let rs = await fetch(`${mainUrl}/DeleteByReportIdAndRoleIds`, requestOptions);
        return await common.handleResponse(rs);
    },
}